/* tslint:disable */
import {
  App,
  Entity,
  Entityrecord
} from '../index';

declare var Object: any;
export interface EntityrecordhistoryInterface {
  data: any;
  action: string;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  appId?: any;
  entityId?: any;
  entityrecordId?: any;
  createdAt: Date;
  updatedAt: Date;
  app?: App;
  entity?: Entity;
  entityrecord?: Entityrecord;
}

export class Entityrecordhistory implements EntityrecordhistoryInterface {
  data: any;
  action: string;
  lastupdatedby: string;
  createdby: string;
  id: any;
  appId: any;
  entityId: any;
  entityrecordId: any;
  createdAt: Date;
  updatedAt: Date;
  app: App;
  entity: Entity;
  entityrecord: Entityrecord;
  constructor(data?: EntityrecordhistoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Entityrecordhistory`.
   */
  public static getModelName() {
    return "Entityrecordhistory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Entityrecordhistory for dynamic purposes.
  **/
  public static factory(data: EntityrecordhistoryInterface): Entityrecordhistory{
    return new Entityrecordhistory(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Entityrecordhistory',
      plural: 'entityrecordshistory',
      properties: {
        data: {
          name: 'data',
          type: 'any'
        },
        action: {
          name: 'action',
          type: 'string',
          default: 'create'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        entityId: {
          name: 'entityId',
          type: 'any'
        },
        entityrecordId: {
          name: 'entityrecordId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
        entity: {
          name: 'entity',
          type: 'Entity',
          model: 'Entity'
        },
        entityrecord: {
          name: 'entityrecord',
          type: 'Entityrecord',
          model: 'Entityrecord'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Entityrecordhistory.ts